import axiosInstance from '../utils/axiosInstance';

const BASE_PATH = '/admin/branch-new-income';

export async function listBranchNewIncome(params = {}) {
  const response = await axiosInstance.get(BASE_PATH, { params });
  return response.data;
}

export async function previewBranchNewIncomeImport(payload) {
  const response = await axiosInstance.post(`${BASE_PATH}/preview-import`, payload);
  return response.data;
}

export async function bulkUpsertBranchNewIncome(payload) {
  const response = await axiosInstance.post(`${BASE_PATH}/bulk-upsert`, payload);
  return response.data;
}

export async function previewAssignCounselor(payload) {
  const response = await axiosInstance.post(`${BASE_PATH}/preview-assign-counselor`, payload);
  return response.data;
}

export async function bulkAssignCounselor(payload) {
  const response = await axiosInstance.post(`${BASE_PATH}/bulk-assign-counselor`, payload);
  return response.data;
}

export async function listBranchIncomeCounselors() {
  const response = await axiosInstance.get(`${BASE_PATH}/counselors`);
  return response.data;
}

export async function deleteBranchNewIncomeById(id) {
  const response = await axiosInstance.delete(`${BASE_PATH}/${id}`);
  return response.data;
}